import { Box, Skeleton } from '@mui/material';

import CheckboxMultipleOutline from '@/assets/icons/CheckboxMultipleOutline';
import Typography from '@/components/Typography';
import type { PastExportDetails } from '@/features/DataHub/api/pastExports.api';
import { ExportDetails } from '@/features/DataHub/components/ExportDetails';
import { ItemDetails } from '@/features/DataHub/components/ItemDetails';

export const ExportItemDetails = ({
  isLoading,
  data,
  optionLabel
}: {
  isLoading: boolean;
  data?: PastExportDetails;
  optionLabel?: string | null;
}) => {
  return (
    <>
      {isLoading && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 1.5 }}>
          <Skeleton
            height='14px'
            width='35%'
          />
          <Skeleton
            height='14px'
            width='55%'
          />
          <Skeleton
            height='14px'
            width='55%'
          />
          <Skeleton height='14px' />
          <Skeleton height='14px' />
        </Box>
      )}
      {!isLoading && data && (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1.5 }}>
            <CheckboxMultipleOutline sx={theme => ({ fontSize: theme.typography.pxToRem(16) })} />
            <Typography
              size={16}
              sx={{ fontWeight: 700 }}
            >
              {data.symbols.length} item{data.symbols.length > 1 ? 's' : ''}
            </Typography>
          </Box>
          <ItemDetails symbols={data.symbols} />
          <ExportDetails
            exportTimestamp={data.exportTimestamp}
            name={optionLabel ?? undefined}
            settings={{
              date: {
                from: data.from,
                to: data.to
              },
              timezone: data.timezone,
              includeMetadata: data.metadata === 'true'
            }}
          />
        </>
      )}
      {!isLoading && !data && <Typography>Failed to load data</Typography>}
    </>
  );
};
